import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'count',
})
export class CountPipe implements PipeTransform {
	private value!: number;

	transform(input: any): string | number | null {
		this.value = typeof input === 'number' ? input : input.length;

		if (Number.isNaN(this.value)) {
			return null;
		}

		if (this.value < 1000) {
			return Math.floor(this.value);
		} else {
			const suffixes = ['K', 'M', 'G', 'T', 'P', 'E'];
			const exp = Math.floor(Math.log(this.value) / Math.log(1000));
			const roundedValue = Math.floor(this.value / Math.pow(1000, exp));
			return `${roundedValue}${suffixes[exp - 1]}`;
		}
	}
}
